'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = personal_order_list;

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    orders: [],
    count: 0
};

function personal_order_list() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.Personal.OrderList.PERSONAL_ORDER_LIST_LOAD:
            return (0, _extends3.default)({}, state);
        case _constants.Personal.OrderList.PERSONAL_ORDER_LIST_SUCCESS:
            return (0, _extends3.default)({}, state, {
                orders: action.result.orders,
                count: action.result.count,
                activePage: action.result.activePage,
                limit: action.result.limit
            });
        case _constants.Personal.OrderList.PERSONAL_ORDER_LIST_FAIL:
            return (0, _extends3.default)({}, state, {
                orders: []
            });
        default:
            return state;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/personal/personal_order_list.js
// module id = 1910
// module chunks = 0